const FEATURES = [
  {
    icon: "\u{1F4B0}",
    iconColor: "card-icon-blue",
    title: "Tuition & fee collection",
    body: "Collect tuition, registration fees, and one-time charges online. Support for payment plans, installments, and sibling discounts built right in.",
  },
  {
    icon: "\u{1F4CB}",
    iconColor: "card-icon-green",
    title: "Enrollment management",
    body: "Online registration, elective enrollment, and waitlist management. Parents submit everything digitally — no more paper forms.",
  },
  {
    icon: "\u{1F35E}",
    iconColor: "card-icon-amber",
    title: "Lunch program",
    body: "Daily menu management with A/B week rotation. Parents order and pay ahead, your kitchen gets an accurate prep count every morning.",
  },
  {
    icon: "\u{1F393}",
    iconColor: "card-icon-purple",
    title: "Scholarships & financial aid",
    body: "Built-in scholarship workflows with approval tracking. Award funds, apply them to balances, and manage overage credits automatically.",
  },
];

export default function Services() {
  return (
    <section className="section section-alt" id="features">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">Features</p>
          <h2 className="section-title">More than a payment processor.</h2>
          <p className="section-lede">
            Easy School Payments handles the full lifecycle — from the day a
            family enrolls to the last tuition payment of the year.
          </p>
        </header>
        <div className="card-grid">
          {FEATURES.map((f) => (
            <article key={f.title} className="card">
              <div className={`card-icon ${f.iconColor}`}>{f.icon}</div>
              <h3 className="card-title">{f.title}</h3>
              <p className="card-body">{f.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
